// components/AxiosInterceptor.tsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { axiosInstance } from '../Services/applicantsService'; // Import your instance

const AxiosInterceptor = ({ children }: { children: any }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Set up the interceptor
    const interceptor = axiosInstance.interceptors.response.use(
      (response: any) => {
        // Check for redirect in the response data
        if (response.data?.redirect) {
          // SPA Redirect!
          navigate(response.data.redirect);
        }
        return response;
      },
      (error: Error) => Promise.reject(error)
    );

    // Cleanup: Eject the interceptor when this component unmounts
    return () => {
      axiosInstance.interceptors.response.eject(interceptor);
    };
  }, [navigate]);

  return children;
};

export default AxiosInterceptor;
